import type { FrequencyKey, FrequencyOption } from './types';

/** Average overdraft fee from the study the disclaimer cites. */
export const OVERDRAFT_FEE = 19.72;

/** Legacy's ceiling, so a high count cannot imply an unbounded SpotMe limit. */
export const MAX_ANNUAL_SAVINGS = 2400;

export const TITLE = 'Overdraft Fee Calculator';

export const COUNT_FIELD = {
  label: 'How Many Times Do You Overdraft?',
  min: 1,
  max: 20,
} as const;

export const DEFAULT_COUNT = 3;

export const FREQUENCY_LEGEND = 'Frequency';

export const FREQUENCY_OPTIONS: readonly FrequencyOption[] = [
  { key: 'weekly', label: 'Weekly' },
  { key: 'monthly', label: 'Monthly' },
  { key: 'annually', label: 'Annually' },
];

/** Overdrafts per year at each frequency. */
export const FREQUENCY_MULTIPLIERS: Record<FrequencyKey, number> = { weekly: 52, monthly: 12, annually: 1 };

export const DEFAULT_FREQUENCY: FrequencyKey = 'weekly';

/** Legacy superscripted the registered mark and a footnote `1`; see the calculator for why the footnote is gone. */
export const RESULT_PROMPT = 'Chime’s Checking Account with SpotMe® could save you up to:';

export const CTA_LABEL = 'Get started';

/** Legacy's destination verbatim; campaign params are appended by the shared link helper. */
export const ENROLLMENT_URL = 'https://app.chime.com/enroll/account';

export const START_OVER_LABEL = 'Start over';

export const BANKRATE_URL = 'https://www.bankrate.com/banking/checking/checking-account-survey/';

/** The `*` is what the result amount's asterisk points at. */
export const DISCLAIMER =
  '*Amount varies based on individual SpotMe limit. Estimate is based on Bankrate’s 2022 Checking Account and ATM Study.';
